import { PageBuilder } from '../../widget-framework/PageBuilder';
import { ConfigPanel } from '../../widget-framework/ConfigPanel';
import { useTabLayout } from './useTabLayout';

export function MonitorTab() {
  const {
    layout, context,
    configPanelInstanceId, configItem,
    handleLayoutChange, handleOpenConfig, handleApplyConfig, closeConfigPanel,
  } = useTabLayout('monitor');

  if (!context) return <div className="tab-loading" aria-label="Loading Monitor" />;

  return (
    <div className="tab-root tab-root--monitor">
      <PageBuilder
        tab={{ id: 'monitor', label: 'Boards Monitor', icon: '📊' }}
        layout={layout}
        surface="custom_object"
        context={context}
        onLayoutChange={handleLayoutChange}
        onOpenConfig={handleOpenConfig}
      />
      <ConfigPanel
        instanceId={configPanelInstanceId}
        widgetId={configItem?.widgetId ?? null}
        currentConfig={configItem?.config ?? {}}
        onApply={handleApplyConfig}
        onClose={closeConfigPanel}
      />
    </div>
  );
}
